var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.342 51.61V28.39a1 1 0 011.496-.869l20.318 11.61a1 1 0 010 1.737l-20.318 11.61a1 1 0 01-1.496-.868z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMzLjM0MTggNTEuNjA5N1YyOC4zODk0QzMzLjM0MTggMjcuNjIxNiAzNC4xNzEzIDI3LjE0MDIgMzQuODM3OSAyNy41MjExTDU1LjE1NTcgMzkuMTMxM0M1NS44Mjc1IDM5LjUxNTIgNTUuODI3NSA0MC40ODM5IDU1LjE1NTcgNDAuODY3OEwzNC44Mzc5IDUyLjQ3NzlDMzQuMTcxMyA1Mi44NTg5IDMzLjM0MTggNTIuMzc3NSAzMy4zNDE4IDUxLjYwOTdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgPlay as ReactComponent };